<script lang="ts" setup>
import type { PropType, ButtonHTMLAttributes } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  type: {
    type: String as PropType<ButtonHTMLAttributes['type']>,
    required: false,
    default: 'button'
  },
  className: {
    type: String,
    required: false,
    default: 'base-button__primary'
  },
  to: {
    type: String,
    required: false,
    default: ''
  },
  disable: {
    type: Boolean,
    required: false,
    default: false
  },
  size: {
    type: String,
    required: false,
    default: 'medium'
  },
  isFullWidth: {
    type: Boolean,
    default: true
  },
  classLoading: {
    type: String,
    required: false,
    default: ''
  },
  isLoadingButton: {
    type: Boolean,
    required: false,
    default: false
  }
})
const router = useRouter()
const emits = defineEmits(['click'])

async function handleClick(): Promise<void> {
  if (!props.disable) {
    if (props.to) {
      await router.push(props.to)
      return
    }
    emits('click')
  }
}
</script>
<template>
  <button
    :class="[
      'base-button button main main--primary',
      `base-button__size--${props.size}`,
      { 'auto-width': !isFullWidth },
      className
    ]"
    :type="type"
    :disable="!!disable"
    @click="handleClick"
  >
    <span v-if="isLoadingButton" class="base-button__loading" :class="[classLoading]">
      <span></span>
      <span></span>
      <span></span>
    </span>
    <slot name="content-before"></slot>
    <span>
      <slot></slot>
    </span>
    <slot name="content-after"></slot>
  </button>
</template>
<style lang="scss" scoped>
@import '~scssAsset/components/common/base-button.scss';
</style>
